import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPasswordTermsCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 11,
	height: 8,
	viewBox: "0 0 11 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.5569 0.292887C10.9475 0.683409 10.9475 1.31657 10.557 1.7071L4.88212 7.38203C4.4916 7.77256 3.85843 7.77257 3.46791 7.38205L0.292902 4.20713C-0.097627 3.81661 -0.0976351 3.18344 0.292884 2.79291C0.683403 2.40238 1.31657 2.40238 1.7071 2.79289L4.17499 5.26072L9.14273 0.292899C9.53325 -0.0976285 10.1664 -0.0976336 10.5569 0.292887Z",
		fill: "#65CA00"
	})
});
export default SvgPasswordTermsCheck;
